module.exports = __webpack_public_path__ + "static/img/200215_2330.e06a315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/200215_2330.png
// module id = 2QLL
// module chunks = 1